import { render, staticRenderFns } from "./ModalCreateNewTeam.vue?vue&type=template&id=24b6b6cd&scoped=true"
import script from "./ModalCreateNewTeam.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b6b6cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b6b6cd')) {
      api.createRecord('24b6b6cd', component.options)
    } else {
      api.reload('24b6b6cd', component.options)
    }
    module.hot.accept("./ModalCreateNewTeam.vue?vue&type=template&id=24b6b6cd&scoped=true", function () {
      api.rerender('24b6b6cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/team/ModalCreateNewTeam.vue"
export default component.exports